/**
 * Normalises a phone number to E.164. Ten-digit Indian mobile numbers get +91 added.
 * Returns null when the input cannot be a valid number.
 */
export const normalizePhone = (input: unknown): string | null => {
    if (typeof input !== 'string') return null

    const trimmed = input.trim()
    const hasPlus = trimmed.startsWith('+')
    let digits = trimmed.replace(/\D/g, '')

    if (!digits) return null

    if (!hasPlus) {
        if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1)
        if (digits.length === 10 && /^[6-9]/.test(digits)) return `+91${digits}`
        if (digits.length === 12 && digits.startsWith('91') && /^[6-9]/.test(digits.slice(2))) return `+${digits}`

        return null
    }

    if (digits.startsWith('91')) {
        return digits.length === 12 && /^[6-9]/.test(digits.slice(2)) ? `+${digits}` : null
    }

    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null
}

export const formatPhone = (e164: string | null | undefined): string => {
    if (!e164) return ''

    const match = /^\+91(\d{5})(\d{5})$/.exec(e164)

    return match ? `+91 ${match[1]} ${match[2]}` : e164
}

export const phoneDigits = (value: string | null | undefined): string => (value ?? '').replace(/\D/g, '')

export const whatsappLink = (number: string | null | undefined, text?: string): string => {
    const digits = phoneDigits(number)
    const base = `https://wa.me/${digits}`

    return text ? `${base}?text=${encodeURIComponent(text)}` : base
}

export const telLink = (number: string | null | undefined): string => `tel:${(number ?? '').replace(/[^\d+]/g, '')}`
